import Routes from './Routes'

export default Routes



// WEBPACK FOOTER //
// ./src/components/Routes/index.js